import template from './templates/help.tmpl.html';
import HelpController from './help-controller';

export default function HelpRoutes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.help', {
        url: '/help',
        views: {
            '': {
                controller: HelpController,
                controllerAs: 'helpCtrl',
                template,
            },
        },
        onEnter: ['$rootScope', function($rootScope) {
            $rootScope.pageHeading = 'Help';
        }],
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/help/help-routes.js